import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Arc } from "../services/db";

interface BrowseChallengesProps {
  challenges: any[];
}

const BrowseChallenges: React.FC<BrowseChallengesProps> = ({ challenges }) => {
  const navigate = useNavigate();

  const handleChallengeClick = (challengeId: string) => {
    console.log('c h : ', challenges);
    navigate(`/browsechallenges/${challengeId}`);
  };

  return (
    <div className="mx-auto pt-4 bg-white">
      <h2 className="text-3xl font-bold text-left ml-8 mb-4">Browse Challenges</h2>
      <div className="grid grid-cols-1 card-body md:grid-cols-2 lg:grid-cols-3 gap-4">
        {challenges.map((challenge) => (
          <div
            key={challenge.arcId}
            className="bg-slate-200 flex flex-col items-start shadow-md rounded-md p-4 cursor-pointer transition duration-300 ease-in-out transform hover:scale-105"
            onClick={() => handleChallengeClick(challenge.arcId)}
          >
            <h3 className="text-lg card-title font-bold mb-2">{challenge.name}</h3>
            <p className="text-sm text-gray-600">Time Period: {challenge.timePeriod} days</p>
            <p className="text-md mt-2 text-black-400 bg-[#F5DD61] rounded-xl px-2">{challenge.category}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrowseChallenges;
